/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./codemirror-wrapper.vue?vue&type=template&id=a026c540&scoped=true"
import script from "./codemirror-wrapper.vue?vue&type=script&lang=js"
export * from "./codemirror-wrapper.vue?vue&type=script&lang=js"
import style0 from "./codemirror-wrapper.vue?vue&type=style&index=0&id=a026c540&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a026c540",
  null
  
)

export default component.exports